/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductCharacteristicsFacet from './ProductCharacteristicsFacet';
import ProductClassificationFacet from './ProductClassificationFacet';
import ProductCountryFacet from './ProductCountryFacet';
import ProductDesignationFacet from './ProductDesignationFacet';
import {
  characteristicsToggled,
  classificationToggled,
  countryToggled,
  designationToggled,
  grapeVarietyToggled,
  // nameToggled,
  productTypeToggled,
  regionToggled,
  subregionToggled,
  vintageToggled,
} from './productFilterReducer';
import ProductGrapeVarietiesFacet from './ProductGrapeVarietiesFacet';
// import ProductNameFacet from '../Filters/Product/ProductNameFacet';
import ProductRegionFacet from './ProductRegionFacet';
import ProductSubregionFacet from './ProductSubregionFacet';
import ProductTypeFacet from './ProductTypeFacet';
import ProductVintageFacet from './ProductVintageFacet';

export default function ProductFilters({
  facets,
  dispatch,
  state,
  totalCount,
  count,
  ...rest
}) {
  return (
    <Box {...rest}>
      <ProductTypeFacet
        allValues={facets.productType}
        selectedValues={state.productTypes}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(productTypeToggled(value), isActive)
        }
      />

      <ProductCharacteristicsFacet
        allValues={facets.characteristics}
        selectedValues={state.characteristics}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(characteristicsToggled(value), isActive)
        }
      />

      <ProductClassificationFacet
        allValues={facets.classification}
        selectedValues={state.classifications}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(classificationToggled(value), isActive)
        }
      />

      <ProductDesignationFacet
        allValues={facets.designation}
        selectedValues={state.designations}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(designationToggled(value), isActive)
        }
      />

      <ProductCountryFacet
        allValues={facets.country}
        selectedValues={state.countries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(countryToggled(value), isActive)
        }
      />
      <ProductRegionFacet
        allValues={facets.region}
        selectedValues={state.regions}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(regionToggled(value), isActive)}
      />
      <ProductSubregionFacet
        allValues={facets.subregion}
        selectedValues={state.subregions}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(subregionToggled(value), isActive)
        }
      />
      <ProductVintageFacet
        allValues={facets.vintage}
        selectedValues={state.vintages}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(vintageToggled(value), isActive)
        }
      />
      <ProductGrapeVarietiesFacet
        allValues={facets.grapeVarieties}
        selectedValues={state.grapeVarieties}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(grapeVarietyToggled(value), isActive)
        }
      />
      {/* <ProductNameFacet
          allValues={facets.name}
          selectedValues={state.names}
          totalCount={totalCount}
          count={count}
          onToggle={(value, isActive) =>
            dispatch(nameToggled(value), isActive)
          }
        /> */}
    </Box>
  );
}

export const fragment = graphql`
  fragment ProductFilters on Product {
    shortName
    vintage(removeNonVintage: true)
    productType
    wineType
    wineColor
    designation
    country(full: true)
    region
    subregion
    characteristics
    grapeVarieties {
      varietyName
    }
  }
`;
